import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ScatterChart, Scatter, XAxis, YAxis, ZAxis, CartesianGrid } from 'recharts';
import { Row, Col, Table } from 'antd';

const data = [
    { name: 'Scope A', value: 25 },
    { name: 'Scope B', value: 30 },
    { name: 'Scope C', value: 20 },
    { name: 'Scope D', value: 20 },
];

const libraryMap = {
    'Main Library': 1,
    'East Branch': 2,
    'West Branch': 3,
    'Children\'s Library': 4,
    'Research Library': 5
};

const materialMap = {
    'Books': 1,
    'eBooks': 2,
    'DVDs': 3,
    'Journals': 4,
    'Magazines': 5
};

const bubbleData = [
    { library: 'Main Library', material: 'Books', count: 500 },
    { library: 'East Branch', material: 'Books', count: 180 },
    { library: 'West Branch', material: 'Books', count: 140 },
    { library: 'Children\'s Library', material: 'DVDs', count: 120 },
    { library: 'Research Library', material: 'Journals', count: 160 },
    { library: 'Main Library', material: 'Magazines', count: 80 },
    { library: 'West Branch', material: 'eBooks', count: 90 },
    { library: 'Children\'s Library', material: 'Magazines', count: 60 },
    { library: 'West Branch', material: 'DVDs', count: 10 },
];

const scatterData = bubbleData.map(item => ({
    x: libraryMap[item.library],
    y: materialMap[item.material],
    z: item.count,
    library: item.library,
    material: item.material,
    count: item.count,
}));

const COLORS = ['#f59689', '#85b4f2', '#a5e2a5', '#fcd3a2'];

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const { library, material, count } = payload[0].payload;
        return (
        <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
            <p>{`Library: ${library}`}</p>
            <p>{`Material: ${material}`}</p>
            <p>{`Count: ${count}`}</p>
        </div>
        );
    }

    return null;
};

// 表格的欄位定義
const columns = [
    {
        title: 'Scoping編號',
        dataIndex: 'scopingNum',
        key: 'scopingNum',
    },
    {
        title: 'Scoping名稱',
        dataIndex: 'scopingName',
        key: 'scopingName',
    },
    {
        title: 'Marc欄位1',
        dataIndex: 'marcField1',
        key: 'marcField1',
    },
    {
        title: 'Marc欄位2',
        dataIndex: 'marcField2',
        key: 'marcField2',
    },
    {
        title: 'Marc欄位3',
        dataIndex: 'marcField3',
        key: 'marcField3',
    },
    {
        title: 'Marc欄位4',
        dataIndex: 'marcField4',
        key: 'marcField4',
    },
    ];

    // 表格資料
    const tableData = [
    {
        key: '1',
        scopingNum: '1',
        scopingName: 'OT館藏區1期刊',
        marcField1: '852 : OT館藏區1',
        marcField2: 'Leader/06 : 期刊',
        marcField3: '-',
        marcField4: '-',
    },
    {
        key: '2',
        scopingNum: '2',
        scopingName: 'OT館藏區1電子書',
        marcField1: '852 : OT館藏區1',
        marcField2: 'Leader/06 : 電子書',
        marcField3: '-',
        marcField4: '-',
    },
    {
        key: '3',
        scopingNum: '3',
        scopingName: 'OT館藏區2期刊',
        marcField1: '852 : OT館藏區2',
        marcField2: 'Leader/06 : 期刊',
        marcField3: '-',
        marcField4: '-',
    },
];

// 定義顏色函數，根據 z 值返回不同顏色
const getColorByCount = (count) => {
    if (count <= 25) return '#7b6d9f';  // 淡紫色
    if (count <= 50) return '#7885aa';  // 淡藍色
    if (count <= 75) return '#769bad';  // 淡綠色
    if (count <= 100) return '#76afae'; // 淡黃色
    if (count <= 125) return '#7ec2a8'; // 淡橙色
    if (count <= 150) return '#9bd59a'; // 粉紅色
    if (count <= 175) return '#c5e481'; // 紅色
    return '#f5ed77'; // 深紅色
};

// 自定義的 Dot 渲染器
const CustomDot = (props) => {
    const { cx, cy, payload } = props;
    const color = getColorByCount(payload.z);  // 根據 z 值來動態設定顏色
    return (
      <circle cx={cx} cy={cy} r={8} fill={color} stroke="none" />
    );
};

    const ColorBar = () => {
        const colorRanges = [
            { count: 200, color: '#f5ed77' },  // 深紅色
            { count: 175, color: '#c5e481' },  // 紅色
            { count: 150, color: '#9bd59a' },  // 粉紅色
            { count: 125, color: '#7ec2a8' },  // 淡橙色
            { count: 100, color: '#76afae' },  // 淡黃色
            { count: 75, color: '#769bad' },   // 淡綠色
            { count: 50, color: '#7885aa' },   // 淡藍色
            { count: 25, color: '#7b6d9f' }    // 淡紫色
        ];

        return (
            <div style={styles.colorBarContainer}>
                {colorRanges.map((range, index) => (
                    <div key={index} style={{ 
                        backgroundColor: range.color, 
                        height: `${100 / colorRanges.length}%`,
                        width: '100%',
                        position: 'relative',
                    }}>
                        {/* 如果 count 等於 200，不顯示 <= 符號 */}
                        <span style={styles.label}>
                            {range.count === 200 ? `` : `<= ${range.count}`}
                        </span>
                    </div>
                ))}
            </div>
        );
    };

// 定義 rowSelection 來實現勾選功能
const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column configuration not to be checked
        name: record.name,
    }),
};
const CategorizationGroupONE = () => {
    return (
    <>
        <div style={styles.searchContainer_title}>
            <Row gutter={[16, 16]} align="middle" style={{paddingTop: '10px'}}>
                <Col span={6}>
                    <div style={{ 
                        padding: '10px', 
                        marginLeft: '20px',
                        backgroundColor: '#e6f7ff', 
                        borderRadius: '10px', 
                        fontWeight: 'bold', 
                        color: '#333', 
                        textAlign: 'center',
                        marginRight: '10px' // 加一點右邊距離
                    }}>
                        常用Scoping選項
                    </div>
                </Col>
                <Col span={18}>
                    <div style={{ 
                        padding: '10px', 
                        marginRight: '20px',
                        backgroundColor: '#e6f7ff', 
                        borderRadius: '10px', 
                        fontWeight: 'bold', 
                        color: '#333', 
                        textAlign: 'center',
                        marginLeft: '10px' // 加一點左邊距離
                    }}>
                        館藏地與館藏類型關係圖
                    </div>
                </Col>
            </Row>
        </div>
        <div style={styles.searchContainer}>
        <Row gutter={[16, 16]} align="middle">
            <Col span={6} style={styles.centerContent}>
            <PieChart width={300} height={300}>
                <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
                >
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
                </Pie>
                <Tooltip />
            </PieChart>
            </Col>
            <Col span={16} style={styles.centerContent}>
                <ScatterChart
                    width={1000}
                    height={300}
                    margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                >
                    <CartesianGrid />
                    <XAxis
                    type="number"
                    dataKey="x"
                    domain={[0, 5]}
                    ticks={[1, 2, 3, 4, 5]}
                    tick={{ fontSize: 12 }}
                    tickFormatter={(tick) =>
                        Object.keys(libraryMap).find(key => libraryMap[key] === tick) || ""
                    }
                    label={{ value: 'Library', position: 'bottom' }}
                    />
                    <YAxis
                    type="number"
                    dataKey="y"
                    domain={[0, 5]}
                    ticks={[1, 2, 3, 4, 5]}
                    tick={{ fontSize: 12 }}
                    tickFormatter={(tick) =>
                        Object.keys(materialMap).find(key => materialMap[key] === tick) || ""
                    }
                    label={{ value: 'Material Type', angle: -90, position: 'left' }}
                    />
                    {/* <ZAxis type="number" dataKey="z" range={[60, 400]} /> */}
                    {/* 使用動態顏色 */}
                    <Scatter
                        name="Library Material Distribution"
                        data={scatterData}
                        shape={<CustomDot />}
                    />
                    <Tooltip content={<CustomTooltip />} />
                </ScatterChart>
            </Col>
            <Col span={2}>
                <ColorBar />
            </Col>
        </Row>
        </div>
        <div style={styles.searchContainer}>
            <Row gutter={[16, 16]} align="middle" style={{ height: '400px', width: '100%' }}>
                <Col span={24} style={styles.centerContent}>
                    <Table
                        rowSelection={{
                            type: 'checkbox', // 可以選擇 'radio' 或 'checkbox'
                            ...rowSelection,
                        }}
                        columns={columns}
                        dataSource={tableData}
                        pagination={false}
                        style={{ width: '100%' }}
                    />
                </Col>
            </Row>
        </div>
    </>
    );
};

export default CategorizationGroupONE;

const styles = {
    searchContainer: {
        margin: '10px',
        justifyContent: 'center',
        alignItems: 'center',
    },
  centerContent: {
    display: 'flex',
    justifyContent: 'center', 
    alignItems: 'center',      
    height: '100%',            
    textAlign: 'center',       
    overflowX: 'auto',
  },
  colorBarContainer: {
    width: '50px', // 色條寬度
    height: '200px', // 色條高度
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #000' // 邊框
  },
  label: {
    color: '#fff',
    fontSize: '12px',
    textAlign: 'center',
    display: 'block',
    padding: '4px'
  }
};
